import React from "react";

/** Site vitrine EasyMarket (distinct de l’URL catalogue AppBaseUrl). */
const EASYMARKET_PLATFORM_URL = "https://www.easymarket.sn";
/** Texte crédit flottant en bas (catalogue). */
export default function CatalogFooterCredit() {
  return (
    <div className="catalog-header-credit" role="contentinfo">
      <span className="catalog-header-credit__line" aria-hidden="true" />
      <span className="catalog-header-credit__text">
        Propulsé par{" "}
        <a
          href={EASYMARKET_PLATFORM_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="catalog-header-credit__link"
        >
          <strong>EasyMarket</strong>
        </a>
      </span>
      <span className="catalog-header-credit__line" aria-hidden="true" />
    </div>
  );
}
